import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginView = _resolveComponent("LoginView")!
  const _component_MainView = _resolveComponent("MainView")!

  return (!_ctx.loginRef)
    ? (_openBlock(), _createBlock(_component_LoginView, {
        key: 0,
        onLoginSuccess: _ctx.onLoginSuccess
      }, null, 8, ["onLoginSuccess"]))
    : (_openBlock(), _createBlock(_component_MainView, { key: 1 }))
}